import { graphql } from '@mp/graphql/generated';
import { type ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

const CurrentUserGql = graphql(`
  query GetCurrentUserForAccountInfoStep {
    me {
      address_zip
      first_name
      last_name
      phone_number
      email
      agency_id
      professional {
        id
        nickname
        referral_source_id
        other_referral_source
      }
    }
  }
`);

export const ReferralSourcesGql = graphql(`
  query GetReferralSourcesForAccountInfoStep($input: ReferralSourceQueryInput) {
    referralSources(input: $input) {
      id
      label
    }
  }
`);

type CurrentUserProps = ResultOf<typeof CurrentUserGql>;

type ReferralSourcesProps = ResultOf<typeof ReferralSourcesGql>;

export const useCurrentUserForAccountInfoStep = () => {
  const { data, isLoading } = useGraphQLQuery<CurrentUserProps>({
    operationName: 'GetCurrentUserForAccountInfoStep',
    query: CurrentUserGql,
    variables: {},
  });
  const currentUser = data?.me;

  return { currentUser, isLoading };
};

export const useReferralSourcesForAccountInfoStep = () => {
  const { data, isLoading } = useGraphQLQuery<ReferralSourcesProps>({
    operationName: 'GetReferralSourcesForAccountInfoStep',
    query: ReferralSourcesGql,
    variables: {
      input: {
        filter: { admin_only: false, applies_to_professionals: true },
        orderBy: { label: true },
      },
    },
  });
  const referralSources = data?.referralSources || [];

  return { referralSources, isLoading };
};
